<template>
  <div class="detail-tab">
    <!-- Status Overview Cards -->
    <v-row class="mb-6">
      <v-col cols="12" sm="6" md="2">
        <v-card class="status-card" :class="getStatusColor">
          <v-card-text class="d-flex align-center">
            <v-icon size="48" color="white" class="mr-4"
              >mdi-file-document-outline</v-icon
            >
            <div>
                <div class="text-overline mb-1">Status</div>
               <div class="text-h6 white--text">
                 {{ filterStages(cf.fileStatus)[0]?.name || "N/A" }}
               </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="2">
        <v-card class="status-card primary">
          <v-card-text class="d-flex align-center">
            <v-icon size="48" color="white" class="mr-4"
              >mdi-office-building</v-icon
            >
            <div>
                <div class="text-overline mb-1">Branch</div>
                <div class="text-h6 white--text">
                 {{ filterBranchName(cf.branch) }}
               </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="2">
        <v-card class="status-card secondary">
          <v-card-text class="d-flex align-center">
            <v-icon size="48" color="white" class="mr-4"
              >mdi-account-tie</v-icon
            >
            <div>
                <div class="text-overline mb-1">Adjuster</div>
                <div class="text-h6 white--text">
                  {{ resolveUserName(cf.adjuster) }}
                </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="2">
        <v-card class="status-card info">
          <v-card-text class="d-flex align-center">
            <v-icon size="48" color="white" class="mr-4">mdi-pencil</v-icon>
            <div>
                <div class="text-overline mb-1">Editor</div>
                 <div class="text-h6 white--text">
                  {{ resolveUserName(cf.editor) }}
                </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="2">
        <v-card class="status-card success">
          <v-card-text class="d-flex align-center">
            <v-icon size="48" color="white" class="mr-4"
              >mdi-check-decagram</v-icon
            >
            <div>
                <div class="text-overline mb-1">Approver</div>
                <div class="text-h6 white--text">
                  {{ resolveUserName(cf.approvedBy) }}
                </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="2">
        <v-card class="status-card deep-purple">
          <v-card-text class="d-flex align-center">
            <v-icon size="48" color="white" class="mr-4"
              >mdi-format-align-justify</v-icon
            >
            <div>
                <div class="text-overline mb-1">Clerk</div>
                <div class="text-h6 white--text">
                  {{ resolveUserName(cf.clerkInCharge) }}
                </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Content -->
    <v-expansion-panels v-model="activePanels" accordion flat hover multiple class="detail-panels">
      <!-- Case Information Panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center justify-space-between w-100">
            <v-icon color="primary" size="24" class="mr-2"
              >mdi-file-document-outline</v-icon
            >
            <span class="panel-title">CASE INFORMATION</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <div v-if="!caseInformationComp">
              <v-skeleton-loader type="list-item-two-line" />
            </div>
            <component
              v-else
              :is="caseInformationComp"
              :casefile="caseState.casefile"
              :branches="branches"
              :refType="refType"
              :subRefTypes="subRefTypes"
              :states="states"
              :members="members"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Insured Details Panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center justify-space-between w-100">
            <v-icon color="primary" size="24" class="mr-2">mdi-account</v-icon>
            <span class="panel-title">INSURED DETAILS</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <div v-if="!insuredDetailsComp">
              <v-skeleton-loader type="list-item-two-line" />
            </div>
            <component
              v-else
              :is="insuredDetailsComp"
              :casefile="caseState.casefile"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Driver Details Panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center justify-space-between w-100">
            <v-icon color="primary" size="24" class="mr-2">mdi-car-back</v-icon>
            <span class="panel-title">INSURED DRIVER DETAILS</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <div v-if="!insuredDriverComp">
              <v-skeleton-loader type="list-item-two-line" />
            </div>
            <component
              v-else
              :is="insuredDriverComp"
              :casefile="caseState.casefile"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Insurance Details Panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center justify-space-between w-100">
            <v-icon color="primary" size="24" class="mr-2"
              >mdi-shield-check</v-icon
            >
            <span class="panel-title">INSURER DETAILS</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-list dense>
                <v-list-item two-line>
                  <v-list-item-icon
                    ><v-icon>mdi-office-building</v-icon></v-list-item-icon
                  >
                  <v-list-item-content>
                    <v-list-item-subtitle>Insurer</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ filterIns(caseState.casefile.insurer)[0]?.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-icon
                    ><v-icon>mdi-numeric</v-icon></v-list-item-icon
                  >
                  <v-list-item-content>
                    <v-list-item-subtitle>Claim No.</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ caseState.casefile.claimNo }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-icon
                    ><v-icon>mdi-file-document</v-icon></v-list-item-icon
                  >
                  <v-list-item-content>
                    <v-list-item-subtitle>Policy/Cover No</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ caseState.casefile.policyNo }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-icon
                    ><v-icon>mdi-calendar-range</v-icon></v-list-item-icon
                  >
                  <v-list-item-content>
                    <v-list-item-subtitle>Coverage</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ formatDate(caseState.casefile.coverFrom) }} -
                      {{ formatDate(caseState.casefile.coverTo) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col cols="12" md="6">
              <v-list dense>
                <v-list-item two-line>
                  <v-list-item-icon
                    ><v-icon>mdi-account-tie</v-icon></v-list-item-icon
                  >
                  <v-list-item-content>
                    <v-list-item-subtitle>Claims Handler</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ filterHandler(caseState.casefile.handler)[0]?.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-icon
                    ><v-icon>mdi-phone</v-icon></v-list-item-icon
                  >
                  <v-list-item-content>
                    <v-list-item-subtitle>Tel</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ filterHandler(caseState.casefile.handler)[0]?.offTel }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-icon
                    ><v-icon>mdi-cellphone</v-icon></v-list-item-icon
                  >
                  <v-list-item-content>
                    <v-list-item-subtitle>Mobile</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ filterHandler(caseState.casefile.handler)[0]?.mobile }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-icon
                    ><v-icon>mdi-email</v-icon></v-list-item-icon
                  >
                  <v-list-item-content>
                    <v-list-item-subtitle>Email</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ filterHandler(caseState.casefile.handler)[0]?.email }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

            <!-- Insurer's Remarks -->
            <v-col cols="12">
              <v-divider class="my-4"></v-divider>
              <v-list-item>
                <v-list-item-icon class="align-self-start mt-2"
                  ><v-icon>mdi-comment-text</v-icon></v-list-item-icon
                >
                <v-list-item-content>
                  <v-list-item-subtitle>Insurer's Remarks</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">
                    <div class="remarks-container">
                      <div
                        :class="[
                          'remarks-text',
                          { 'remarks-collapsed': !showFullRemarks },
                        ]"
                      >
                        {{ caseState.casefile.insComment }}
                      </div>
                      <v-btn
                        v-if="caseState.casefile.insComment?.length > 150"
                        text
                        small
                        color="primary"
                        class="px-0 mt-1"
                        @click="showFullRemarks = !showFullRemarks"
                      >
                        {{ showFullRemarks ? "Show Less" : "Show More" }}
                      </v-btn>
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<style scoped>
.detail-tab {
  padding: 16px;
}

.status-card {
  transition: transform 0.2s;
  border-radius: 8px !important;
}

.status-card:hover {
  transform: translateY(-4px);
}

.status-card .v-card__text {
  padding: 20px;
}

.text-overline {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.75rem;
  font-weight: 500;
}

.v-list-item {
  min-height: 56px !important;
}

.v-list-item__subtitle {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
}

.v-list-item__title {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.v-expansion-panels {
  border-radius: 8px;
}

.v-expansion-panel {
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}

.v-expansion-panel-header {
  padding: 16px;
  font-weight: 500;
}

.v-expansion-panel-content__wrap {
  padding: 16px;
}

.detail-panels {
  margin-bottom: 24px;
}

.status-card .text-h6 {
  font-size: 0.9rem !important;
  line-height: 1.2;
  word-break: break-word;
}

.text-subtitle-2 {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
  font-weight: 500;
}

.panel-title {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.0892857143em;
  color: var(--v-primary-base);
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
  position: relative;
  padding-bottom: 4px;
}

.panel-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: currentColor;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.v-expansion-panel-header--active .panel-title::after {
  transform: scaleX(1);
}

.remarks-container {
  position: relative;
  width: 100%;
}

.remarks-text {
  white-space: pre-wrap;
  word-break: break-word;
  transition: max-height 0.3s ease;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.87);
  padding-bottom: 24px; /* Add padding to prevent text from being cut off by gradient */
}

.remarks-collapsed {
  max-height: 60px;
  overflow: hidden;
  position: relative;
}

.remarks-collapsed::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: linear-gradient(to bottom, transparent, white 100%);
}
</style>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "detailTab",
  props: [
    "adjusters",
    "editors",
    "clerks",
    "branches",
    "insurer",
    "handlers",
    "refType",
    "subRefTypes",
    "members",
    "stages",
    "states",
    "casefile",
  ],
  components: {},

  data() {
    return {
      showFullRemarks: false,
      // expansion control
      activePanels: [],
      caseInformationComp: null,
      insuredDetailsComp: null,
      insuredDriverComp: null,
    };
  },

  computed: {
    ...mapState(["caseState"]),

    // prefer parent-provided casefile prop for immediate rendering; fallback to store
    cf() {
      return this.casefile || (this.caseState && this.caseState.casefile) || {};
    },

    getStatusColor() {
      const status = this.cf.fileStatus;
      const colors = {
        NEW: "success",
        PEND: "warning",
        INVE: "info",
        COMP: "error",
        // Add more status colors as needed
      };
      return colors[status] || "grey";
    },
  },

  watch: {
    activePanels(newVal) {
      this.ensurePanelComponents(newVal || []);
    },
  },

    methods: {
      moment: function (date) {
        return moment(date);
      },

      // Resolve user display name robustly from multiple possible shapes
      resolveUserName(userRef) {
        if (!userRef) return "To be assigned";
        // If the casefile stored a full user object
        if (typeof userRef === "object" && userRef.username) return userRef.username;
        // If userRef is an id, try to find it in members (parent-provided) or store
        const id = String(userRef);
        const local = (this.members || []).find((m) => String(m.id) === id);
        if (local && local.username) return local.username;
        const storeMember = (this.$store.state.referenceData.members || []).find((m) => String(m.id) === id);
        if (storeMember && storeMember.username) return storeMember.username;
        // fallback to raw id
        return String(userRef);
      },

    filterSubDept(item) {
      return this.subRefTypes.filter((subRef) => subRef.id === item);
    },

    yearOnly(value) {
      // return moment(value).format("YYYY");
      return moment(value).format("YY");
    },

    filterStages(item) {
      return this.stages.filter((stage) => stage.stageCode === item);
    },
    filterDept(item) {
      return this.refType.filter((dept) => dept.id === item);
    },

    filterIns(item) {
      return this.insurer.filter((insurer) => insurer.id === item);
    },
    filterAdj(item) {
      // Coerce to string for robust id matching (numbers vs strings)
      return this.adjusters.filter((adjuster) => String(adjuster.id) === String(item));
    },
    filterEditor(item) {
      return this.editors.filter((editor) => String(editor.id) === String(item));
    },
    filterApprover(item) {
      return this.members.filter((approver) => String(approver.id) === String(item));
    },
    filterClerk(item) {
      return this.clerks.filter((clerk) => String(clerk.id) === String(item));
    },
    filterBranches(item) {
      return this.branches.filter((branch) => String(branch.id) === String(item));
    },
    filterStates(item) {
      return this.states.filter((state) => String(state.id) === String(item));
    },
    filterHandler(item) {
      return this.handlers.filter((handler) => String(handler.id) === String(item));
    },
    filterUser(item) {
      return this.members.filter((member) => String(member.id) === String(item));
    },

    formatDate: function (date) {
      if (!date) return "";
      return moment(date).format("DD/MM/YYYY");
    },
    formatTime: function (date) {
      if (!date) return "";
      return moment(date).format("h:mm:ss a");
    },
    dateDiff(startDateString, endDateString) {
      // Method 01
      let start = moment(startDateString);
      let end = moment(endDateString);
      let duration = moment.duration(end.diff(start));
      return Math.round(duration.asDays());

      // Method 02
      // var start = moment(startDateString); //todays date
      // var end = moment(endDateString); // another date
      // var duration = moment.duration(end.diff(start));
      // var days = duration.asDays();
      // return Math.round(days);
    },
    refreshList() {
      // this.retrieveCasefiles(this.$route.params.id);
      // this.retrieveAllCase();
    },
    filterBranchName(item) {
      if (!item) return "To be assigned";
      const branch = this.branches.find((branch) => branch.id === item);
      return branch ? branch.name : "Unknown Branch";
    },
    // Lazy-load panel components when their panel is opened (first time)
    ensurePanelComponents(openIndexes) {
      // openIndexes may be a number or array depending on props; normalize to array
      const open = Array.isArray(openIndexes) ? openIndexes : [openIndexes];
      // CaseInformation is panel index 0
      if (open.includes(0) && !this.caseInformationComp) {
        // dynamic import the component
        import("./panels/CaseInformationBody.vue").then((m) => {
          this.caseInformationComp = m.default || m;
        });
      }
      // Insured Details panel index 1
      if (open.includes(1) && !this.insuredDetailsComp) {
        import("./panels/InsuredDetailsBody.vue").then((m) => {
          this.insuredDetailsComp = m.default || m;
        });
      }
      // Insured Driver panel index 2
      if (open.includes(2) && !this.insuredDriverComp) {
        import("./panels/InsuredDriverDetailsBody.vue").then((m) => {
          this.insuredDriverComp = m.default || m;
        });
      }
    },
  },
  mounted() {
    // this.retrieveCasefiles(this.$route.params.id);
    // If any panels are pre-open, ensure components are loaded
    if (this.activePanels && this.activePanels.length) {
      this.ensurePanelComponents(this.activePanels);
    }
  },
};
</script>
